module.exports = __webpack_public_path__ + "static/media/catalyst-bg-4.1c680aef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/catalyst-bg-4.svg
// module id = 1125
// module chunks = 0